import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { PRODUCTS } from './MetaPixel';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard, CheckCircle2 } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Chile',
    product: 'Compró el MEGAPACK',
    text: 'Antes llegaba agotada al lunes. Ahora abro el tomo y en 5 minutos tengo la clase armada.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'Colombia',
    product: 'Compró el MEGAPACK',
    text: 'Lo compré con algo de desconfianza y me sorprendió: está mucho más completo de lo que esperaba.',
    bg: 'bg-brandBlue-electric'
  }, {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'México',
    product: 'Compró el MEGAPACK',
    text: 'Los warm-ups y los cierres me salvaron. Se nota que la clase tiene orden de principio a fin.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Uruguay',
    product: 'Compró el MEGAPACK',
    text: 'Me ahorró muchísimo tiempo. Ya no pierdo los domingos armando sesiones. Muy recomendable.',
    bg: 'bg-brandBlue-electric'
  }];
  return <Section className="bg-bg-alt" data-id="element-166" data-mp="3gb0ozkzrrxhb">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-167" data-mp="3ubbh0rctfi42">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary mb-3 md:mb-4 text-[32px]" data-id="element-168" data-mp="3ua0gd0eo2qh6">
          Lo que dicen <span className="text-brandOrange" data-id="element-169" data-mp="3pafeah47a208">los profes</span>
        </h2>
        <div className="inline-flex items-center gap-2 bg-bg-card border border-line rounded-full px-4 py-2" data-id="element-170" data-mp="1zxu0hoatvlij">
          <div className="flex text-gold" data-id="element-171" data-mp="1v022qdni556f">
            {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-current" data-id="element-172" data-mp="3v21lybhkiwim" data-mpi={j} />)}
          </div>
          <span className="font-sans font-bold text-txt-primary text-sm" data-id="element-173" data-mp="3upbefb6xhbo">
            4.9/5
          </span>
          <span className="font-sans text-txt-muted text-xs md:text-sm" data-id="element-174" data-mp="7ufx44lv179c">
            · +150 entrenadores de Latinoamérica
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-175" data-mp="hsvqyfc9uumj">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-176" data-mp="mrgog705307a" data-mpi={i}>
            <div className="bg-bg-card p-4 md:p-5 rounded-[16px] border border-line h-full flex flex-col" data-id="element-177" data-mp="rjhzxqphgmw9">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-178" data-mp="vllguuux8jox">
                <div className={`w-9 h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-xs shrink-0`} data-id="element-179" data-mp="10kg7uk31lek4">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-180" data-mp="1fnpxausou2it">
                  <div className="flex text-gold mb-0.5" data-id="element-181" data-mp="1fld75ucs0luo">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-182" data-mp="1aqpssobhl7tt" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[13px] leading-tight" data-id="element-183" data-mp="11nyfsk2yq402">
                    {t.name}
                  </p>
                  <p className="text-[11px] font-sans text-txt-muted" data-id="element-184" data-mp="1ydfutpnu52ef">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[13px] md:text-[14px] leading-[1.5] italic mb-2.5" data-id="element-185" data-mp="1oncoyovm7tyo">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandOrange mt-auto" data-id="element-186" data-mp="1kkgc7esras2n">
                {t.product}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-base" data-id="element-187" data-mp="1wxs9o727nmk1">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-188" data-mp="21vbmd2j9fr9v">
        <div className="bg-bg-card border border-[rgba(34,197,94,0.2)] rounded-[20px] p-6 md:p-10 relative overflow-hidden" data-id="element-189" data-mp="21w3ge8x7lgy1">
          <div className="absolute inset-0 bg-gradient-to-b from-[rgba(212,164,28,0.05)] to-transparent pointer-events-none" data-id="element-190" data-mp="1rwmhcacgq1b1"></div>
          <ShieldCheck size={70} className="mx-auto text-success mb-5 md:mb-6 relative z-10" data-id="element-191" data-mp="2flxap6rhgtf5" />
          <h2 className="font-display font-extrabold uppercase text-[26px] md:text-[44px] leading-[1.1] text-txt-primary mb-6 md:mb-8 relative z-10" data-id="element-192" data-mp="2kkrxejskn24j">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body space-y-3 md:space-y-4 mb-6 md:mb-8 relative z-10" data-id="element-193" data-mp="2atdv6498jo7p">
            <p data-id="element-194" data-mp="33ct60dv5e6r5">Abres los tomos. Los usas en tus clases.</p>
            <p className="font-sans font-bold text-lg md:text-xl text-txt-primary leading-snug py-2" data-id="element-195" data-mp="rwsnefnqnz3v">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-196" data-mp="mwxuk6kekzg6" />
              devolución del 100%.
            </p>
            <p data-id="element-197" data-mp="11mvf8cj4j70m">Sin formularios. Sin complicaciones. Sin vueltas.</p>
          </div>
          <p className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-txt-muted relative z-10" data-id="element-198" data-mp="wnsmnrkbyt9j">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve para cualquier nivel de grupo?',
    a: 'Sí. Cada sesión incluye Versión A para principiantes, Versión B para intermedios y Versión C para avanzados. Puedes dictar la misma clase a un grupo mixto sin problema.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio está en dólares (USD $16), pero el cobro se realiza en tu moneda local: la conversión es automática al finalizar la compra. No necesitas cuenta en dólares.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibes un correo con el link de descarga. En menos de 5 minutos tienes todo en tu celular, tablet o computadora.'
  }, {
    q: '¿Necesito equipamiento especial para usarlo?',
    a: 'No. La mayoría de las sesiones se pueden dictar con equipamiento básico de cualquier gimnasio: mancuernas, kettlebells y bandas. Cada sesión indica los materiales necesarios con íconos.'
  }, {
    q: '¿Funciona si soy instructor de gimnasio y no profesor de escuela?',
    a: 'Este producto fue creado específicamente para instructores y coaches de funcional en gimnasios, boxes y grupos. Es exactamente para ti.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. Si no es lo que esperabas, envías un correo y devolvemos el 100% del pago. Sin formularios. Sin complicaciones.'
  }, {
    q: '¿Puedo usar el MEGAPACK con más de un grupo?',
    a: 'Sí. Puedes dictar las sesiones en todos tus grupos y horarios, sin límite. Es tuyo para siempre: lo descargas una vez y lo usas todo el año.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-alt" data-id="element-199" data-mp="345if74cfdalc">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-200" data-mp="2z7z3oc743bx3">
        <h2 className="font-display font-extrabold uppercase text-[28px] md:text-[44px] leading-[1.1] text-txt-primary text-center mb-8 md:mb-10" data-id="element-201" data-mp="2z6xi3dsgz714">
          ❓ LO QUE MÁS NOS <span className="text-brandOrange" data-id="element-202" data-mp="2pifi2ys0l3yj">PREGUNTAN</span>
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-203" data-mp="2pg2v277eg3em">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-line rounded-[16px] overflow-hidden transition-colors ${openIndex === i ? 'bg-bg-highlight' : ''}`} data-id="element-204" data-mp="2lgtxssd5hneb" data-mpi={i}>
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-205" data-mp="2bkikbz1tqria">
                <span className="font-sans font-bold text-[14px] md:text-[16px] text-txt-primary" data-id="element-206" data-mp="38eu457cwde9">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandOrange shrink-0" size={20} data-id="element-207" data-mp="3qdcsg04klr2w" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-208" data-mp="3bogn4atwes5z" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body border-t border-line pt-4" data-id="element-209" data-mp="32otkjlpfngbc">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3hs buscando sesiones por semana',
    costo: '156hs por año'
  }, {
    sin: 'Clases sin estructura',
    costo: 'Grupo que abandona'
  }, {
    sin: 'Sin adaptaciones por nivel',
    costo: 'El alumno nuevo no vuelve'
  }, {
    sin: 'Sin programa anual',
    costo: 'Los mismos circuitos'
  }, {
    sin: 'Domingo buscando ideas en redes',
    costo: 'Mismo ciclo cada año'
  }];
  return <Section className="bg-bg-base" data-id="element-210" data-mp="2x2azp92m895p">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-211" data-mp="2x19l4ume54j8">
        <h2 className="font-display font-extrabold uppercase text-[32px] md:text-[44px] leading-[1.1] text-center text-txt-primary mb-8 md:mb-12" data-id="element-212" data-mp="2t1h742e8a66h">
          ⚖️ ¿CUÁNTO CUESTA
          <br data-id="element-213" data-mp="36ugne6lu44f3" />
          <span className="text-brandOrange" data-id="element-214" data-mp="31tj9i67uxwje">NO TENERLO?</span>
        </h2>

        <div className="bg-bg-card rounded-[16px] md:rounded-[20px] overflow-hidden border border-line mb-8 md:mb-10" data-id="element-215" data-mp="31vm5d6voyjw1">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5" data-id="element-216" data-mp="3brp9gia3sslm">
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-muted" data-id="element-217" data-mp="3bpm6yyrrl700">
              Sin el MEGAPACK
            </div>
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-primary pl-3 md:pl-5 border-l border-line" data-id="element-218" data-mp="396ijbb8xch7j">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-219" data-mp="306c67qh51j8w">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5 items-center" data-id="element-220" data-mp="304j3undk5l6p" data-mpi={i}>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-txt-muted pr-2" data-id="element-221" data-mp="3ryl3gwkryfmj">
                  {row.sin}
                </div>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-danger font-medium pl-3 md:pl-5 border-l border-line flex items-center gap-1.5" data-id="element-222" data-mp="3ix3ojhj3sjzf">
                  <span data-id="element-223" data-mp="27hok5sokepua">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <p className="font-sans font-bold text-[14px] md:text-xl text-center text-txt-primary w-full mx-auto" data-id="element-224" data-mp="n0fcu6rwtqbd">
          Tu próximo entrenamiento puede ser diferente...
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-bg-alt border-t border-line pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-225" data-mp="10s2kf2rayl9g">
      <FadeIn className="max-w-[700px] mx-auto text-center" data-id="element-226" data-mp="15qx2u3lcy7t1">
        {/* Urgency intro copy */}
        <div className="mb-8 md:mb-10" data-id="element-227" data-mp="1aofdpzixqx3o">
          <p className="font-display font-extrabold uppercase text-[30px] md:text-[40px] leading-[1.15] text-txt-primary" data-id="element-228" data-mp="1andq6vkqgi52">
            Puedes{' '}
            <span className="text-brandOrange" style={{
            textShadow: '0 0 12px rgba(255,107,0,0.22)'
          }} data-id="element-229" data-mp="1jqeviu1ry57o">
              improvisar
            </span>{' '}
            la siguiente clase,
            <br data-id="element-230" data-mp="3lhjivdwocjm7" />
            o entrar con todo resuelto.
          </p>
          <p className="font-display font-black uppercase text-[30px] md:text-[40px] leading-[1.15] text-brandOrange animate-pulse" data-id="element-231" data-mp="snkq59qucmyh">
            Tú decides.
          </p>
        </div>

        <div className="mb-10 md:mb-12" data-id="element-232" data-mp="11npvzfgdzdaj">
          <div className="inline-flex items-center gap-1.5 bg-danger/15 border border-danger/40 text-danger font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 rounded-full mb-3 animate-pulse" data-id="element-233" data-mp="11ld68g4dzymx">
            <span className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" data-id="element-234" data-mp="16mkhip5qnfyc"></span>
            🚨 ÚLTIMA OPORTUNIDAD
          </div>
          <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-brandOrange mb-3 md:mb-4" data-id="element-235" data-mp="1laf9g3bx9gad">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="inline-flex items-center gap-2 md:gap-3 bg-bg-card border-2 border-brandOrange px-5 py-3 md:px-6 md:py-4 rounded-[14px] shadow-[0_0_30px_rgba(255,107,0,0.4)] animate-glow-button" data-id="element-236" data-mp="1ubvjub2qliel">
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandOrange leading-none" data-id="element-237" data-mp="28z3qcyl3ozk8">
              {hours.toString().padStart(2, '0')}
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandOrange leading-none" data-id="element-238" data-mp="1zy5u52gwlwc7">
              :
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandOrange leading-none" data-id="element-239" data-mp="23ypmlsqj8bs0">
              {minutes.toString().padStart(2, '0')}
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandOrange leading-none" data-id="element-240" data-mp="1uzceb3e59t8v">
              :
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandOrange leading-none" data-id="element-241" data-mp="1g83i2bfql9mr">
              {seconds.toString().padStart(2, '0')}
            </span>
          </div>
          <p className="font-sans font-bold text-[11px] md:text-[13px] text-danger mt-3 uppercase tracking-[1.5px]" data-id="element-242" data-mp="17bl3634cbm96">
            Después sube. No vuelve a este precio.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10 md:mb-12" data-id="element-243" data-mp="1473saqbjftcj">
          <div className="bg-bg-card rounded-[22px] p-5 md:p-8 border-2 border-brandOrange text-left shadow-[0_0_50px_rgba(255,107,0,0.2),inset_0_0_30px_rgba(255,107,0,0.03)]" data-id="element-244" data-mp="z8it8u80vfpo">
            <h4 className="font-display font-extrabold uppercase text-[20px] md:text-[26px] leading-[1.1] text-txt-primary text-center" data-id="element-245" data-mp="qgqkcnyncen7">
              MEGAPACK FUNCIONAL <span className="text-brandOrange" data-id="element-246" data-mp="lip5ygc613i2">365™</span>
            </h4>
            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mt-2 mb-3 md:mb-4" data-id="element-247" data-mp="ghj9q8jaqy3s">
              Lo que incluye:
            </p>

            <ul className="space-y-2 md:space-y-2.5" data-id="element-248" data-mp="7io34vccblzy">
              {['6 Tomos principales — 365 sesiones', '5 Bonos estratégicos incluidos', 'Versiones A/B/C por nivel', 'Acceso inmediato y para siempre'].map(item => <li key={item} className="flex items-start gap-2" data-id="element-249" data-mp="3jshai7r216vc">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-250" data-mp="3ortwkqa3q9wv" />
                  <span className="font-sans text-[12.5px] md:text-[15px] leading-[1.45] text-txt-body" data-id="element-251" data-mp="3tjlph7gqcrq6">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-4 md:mt-5 pt-3 md:pt-4 border-t border-line text-center" data-id="element-252" data-mp="30w91qtyu2dva">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-253" data-mp="35u130eldbcc5">
                Precio original
              </p>
              <p className="font-display font-black text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-254" data-mp="3eufq9jhw71ia">
                USD $79
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandOrange/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-255" data-mp="u3fb5gmycq38">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandOrange" data-id="element-256" data-mp="2q5s49dp2yuja">
                Acceso completo hoy por
              </p>
              <p className="font-display font-black text-[44px] md:text-[60px] leading-none text-brandOrange mt-1" data-id="element-257" data-mp="305j31rkobvp6">
                $16{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-258" data-mp="2v6zb9ajefpow">
                  USD
                </span>
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-259" data-mp="22iaajcm99mdo">
                Pago único · Incluye garantía de 7 días
              </p>
            </div>

            <LocalCurrencyNote className="mt-3 md:mt-4" data-id="element-260" data-mp="2cfyduqxxg27g" />

            <div className="mt-4 md:mt-5" data-id="element-261" data-mp="2cedix07pah92">
              <CTAButton href={PRODUCTS.megapack.checkoutUrl} fullWidth trackingProduct="megapack" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[14px] md:!text-base" data-id="element-262" data-mp="1opkl0y7ipzbt">
                QUIERO EL MEGAPACK COMPLETO
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-263" data-mp="3me7ywolohdo4">
          <span className="flex items-center gap-2" data-id="element-264" data-mp="3qgbbxhnzwqbi">
            <Lock size={14} data-id="element-265" data-mp="hzgjkw4tqobo" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-266" data-mp="hzzq7gp0xqae">
            <Clock size={14} data-id="element-267" data-mp="mz2x76oke6l0" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-268" data-mp="mwgnb0e7bezm">
            <ShieldCheck size={14} data-id="element-269" data-mp="8xqiszp1yd18" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-270" data-mp="dxmnl15kq8hu">
            <CreditCard size={14} data-id="element-271" data-mp="dzpmybsm9dz8" /> Tarjeta | Débito | Pago local en tu moneda
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-line py-12 px-6" data-id="element-272" data-mp="2ypex4bidkbll">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-273" data-mp="3pf8lcsmzwnmy">
        <div data-id="element-274" data-mp="3lctxtv8dszpc">
          <h2 className="font-display font-black text-xl text-txt-primary mb-1" data-id="element-275" data-mp="3lcc6nd0ktboa">
            🏋️ MEGAPACK FUNCIONAL 365™
          </h2>
          <p className="font-sans font-bold text-sm text-brandOrange" data-id="element-276" data-mp="3ge0u2uiwcn2d">
            by CENTER SHOP DIGITAL
          </p>
        </div>

        <p className="font-sans text-[13px] text-txt-muted max-w-md mx-auto" data-id="element-277" data-mp="cwsgimv7c9dg">
          El sistema de clases listas número 1 para instructores y coaches de
          funcional en Latinoamérica. Porque dar una buena clase no debería
          costarte todos los domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 font-sans text-[13px] text-txt-muted pt-4" data-id="element-278" data-mp="34mfknmz2hm4">
          <a href="mailto:soportecentershop95@gmail.com" className="hover:text-txt-primary transition-colors" data-id="element-279" data-mp="vnjllc85pdm1">
            📧 soportecentershop95@gmail.com
          </a>
          <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-280" data-mp="y8remsamfr3b">
            📲 @centershop.digital
          </a>
        </div>

        <div className="pt-8 border-t border-line space-y-3" data-id="element-281" data-mp="138vjtm62wze8">
          <p className="font-sans text-xs text-txt-faint" data-id="element-282" data-mp="184udnpa6f9m1">
            © 2024 Center Shop Digital. Todos los derechos reservados. Precios
            en dólares (USD) · Cobro en tu moneda local.
          </p>
          <p className="space-x-4 font-sans text-xs text-txt-faint" data-id="element-283" data-mp="1h5smckvk85ay">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-284" data-mp="1m554isbhko77">
              Términos y condiciones
            </a>
            <span data-id="element-285" data-mp="1qxon63p169iv">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-286" data-mp="1qygfn5nbzr4x">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};